import { ProjectSubTypeBase } from './base/project-sub-type-base';

export class ProjectSubType extends ProjectSubTypeBase { }